/**
 * Bandeau discret « complétez votre nom » (spec onboarding fluide, D-A4).
 *
 * Affiché quand `user.nameFallback` est vrai : le nom en base est un repli (partie locale de
 * l'e-mail, ou placeholder du fournisseur) et non un vrai prénom/nom. Pas de formulaire ici —
 * `ProfilePage` a déjà le champ, la validation et appelle `refreshSession()` après
 * enregistrement, ce qui fait disparaître le bandeau tout seul. La fermeture est mémorisée
 * pour la session du navigateur (`sessionStorage`), pas davantage : le nom reste à compléter.
 */

import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSession } from '../contexts/SessionContext.jsx';
import { BTN_GHOST_SM } from '../ui/theme.js';

const DISMISS_KEY = 'exiplan.nameBanner.dismissed';

function dejaMasque() {
  try {
    return sessionStorage.getItem(DISMISS_KEY) === '1';
  } catch {
    return false;
  }
}

export function NameFallbackBanner() {
  const { t } = useTranslation();
  const { user } = useSession();
  const [masque, setMasque] = useState(dejaMasque);

  if (!user?.nameFallback || masque) return null;

  const masquer = () => {
    try {
      sessionStorage.setItem(DISMISS_KEY, '1');
    } catch {
      // Stockage indisponible : le bandeau se masque quand même pour cette page.
    }
    setMasque(true);
  };

  return (
    <div
      role="status"
      className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 border-b-2 border-line bg-surface-2 px-3 py-1.5 text-center text-xs text-ink-soft"
    >
      <span>{t('nameBanner.body', { name: user.name })}</span>
      <span className="flex items-center gap-2">
        <Link to="/compte?onglet=profil" className={BTN_GHOST_SM}>
          {t('nameBanner.action')}
        </Link>
        <button type="button" className={BTN_GHOST_SM} onClick={masquer}>
          {t('nameBanner.dismiss')}
        </button>
      </span>
    </div>
  );
}
